module.exports = __webpack_public_path__ + "img/pager1img.51929afd.png";